import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "campaign-goal-editor",
  "data-testid": "marketing-campaign-goal-editor"
}
const _hoisted_2 = { class: "campaign-goal-title-row" }
const _hoisted_3 = {
  key: 0,
  class: "campaign-goal-loading"
}
const _hoisted_4 = { class: "campaign-goal-label-row" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "campaign-goal-meta" }
const _hoisted_8 = { class: "campaign-goal-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "施策目標", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(['campaign-goal-state', _ctx.goal?.configured ? 'configured' : 'unconfigured'])
          }, _toDisplayString(_ctx.goal?.configured ? "設定済み" : "未設定"), 3)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, " この施策の目標や今後の方針を自由に入力できます。週次レポートでは、生成を依頼した時点の内容を固定して参照します。 ", -1))
      ]),
      (_ctx.conflicted)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "secondary",
            "data-testid": "marketing-goal-reload",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
          }, " 最新版を再読み込み "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "読み込み中..."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "marketing-campaign-goal-prompt" }, "目標・計画プロンプト", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "secondary",
              "data-testid": "marketing-goal-insert-draft",
              disabled: !_ctx.canInsertDraft,
              title: _ctx.canInsertDraft ? '' : '入力欄が空のときだけ使えます（既存の目標は上書きしません）',
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.insertDraft && _ctx.insertDraft(...args)))
            }, " 雛形を推測値で入れる ", 8, _hoisted_5)
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "campaign-goal-draft-note" }, " 獲得目標キーワード・対象URL・最終成果イベントから雛形を埋めます。推測した箇所は「（推測設定）」と書かれます。保存するまで反映されません。 ", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "marketing-campaign-goal-prompt",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.promptText) = $event)),
            rows: "13",
            "data-testid": "marketing-goal-prompt",
            disabled: _ctx.saving,
            placeholder: "この施策で達成したいことや、今週強化したい方向性などを自由に入力してください。",
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetTransientStatus && _ctx.resetTransientStatus(...args)))
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.promptText]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["campaign-goal-count", { over: _ctx.characterCount > _ctx.maxLength }])
          }, _toDisplayString(_ctx.characterCount.toLocaleString()) + " / " + _toDisplayString(_ctx.maxLength.toLocaleString()) + "文字 ", 3),
          _cache[11] || (_cache[11] = _createStaticVNode("<details class=\"campaign-goal-guide\" data-v-54822ca0><summary data-v-54822ca0>入力するときの観点（任意）</summary><ul data-v-54822ca0><li data-v-54822ca0>この施策で達成したいこと</li><li data-v-54822ca0>対象ユーザー</li><li data-v-54822ca0>数値目標と期限</li><li data-v-54822ca0>優先する商品・サービス</li><li data-v-54822ca0>今週強化したい方向性</li><li data-v-54822ca0>避けたい訴求や記事テーマ</li><li data-v-54822ca0>記事から誘導したいCTA</li></ul><p data-v-54822ca0>テンプレートに沿う必要はありません。自由記述で保存できます。</p></details>", 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, "版 " + _toDisplayString(_ctx.goal?.version || 0), 1),
            _createElementVNode("span", null, "最終更新 " + _toDisplayString(_ctx.formatDate(_ctx.goal?.updated_at)), 1)
          ]),
          (_ctx.statusMessage)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(['campaign-goal-message', _ctx.statusKind]),
                "data-testid": "marketing-goal-status",
                role: "status"
              }, _toDisplayString(_ctx.statusMessage), 3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              "data-testid": "marketing-goal-save",
              disabled: !_ctx.canSave,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _toDisplayString(_ctx.saving ? "保存中..." : "保存"), 9, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "secondary",
              "data-testid": "marketing-goal-cancel",
              disabled: _ctx.saving || !_ctx.dirty,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, " キャンセル ", 8, _hoisted_10),
            _createElementVNode("button", {
              type: "button",
              class: "danger",
              "data-testid": "marketing-goal-clear",
              disabled: _ctx.saving || !_ctx.goal?.configured,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
            }, " 未設定に戻す ", 8, _hoisted_11)
          ])
        ], 64))
  ]))
}